import { getAccount } from "wagmi/actions";
import { wagmiConfig, } from "@config";



export const assertUserStaked = async ( ) => {
	const { address, } = getAccount(wagmiConfig);
	if(address) {
		const response = await fetch("/update/user", {
			method: "POST",
			body: JSON.stringify({
				user: { wallet: address, staked: true, }
			})
		});
		if(response.ok) {
			const result = await response.json();
			if(result.success && result.staked) {
				return true;
			}
		}
	}	
	// let it through, a server warning will have been generated and lets not interrupt the otherwise "working" transaction.
}
